module.exports = __webpack_public_path__ + "static/assets/b25d2024b65e26407d2fea2f7bae7cd2.gif";